import { FilterIcon } from "@src/assets/icons/FilterIcon";
import Button from "@src/components/Button/Button";
import { ButtonVariant } from "@src/components/Button/Button.constants";
import { DatePicker } from "@src/components/DatePicker/DatePicker";
import { FiltersProps } from "@src/components/Header/Header.constants";
import { Input } from "@src/components/Input/Input";
import { useRef } from "react";
import { Control, UseFormReset, UseFormSetValue, useWatch } from "react-hook-form";
import { SelectYup } from "../../Select/SelectYup";
import { Modal, ModalHandle } from "../Modal";
import { DatePickersContainer, FilterButtonInnerContainer } from "./FiltersModal.styled";
import { GridSection } from "./GridSection";
import { filterVisibleMarketplaceOptions } from "@src/constants/marketplaceVisibility";

interface FiltersModalProps {
	control: Control<FiltersProps>;
	setValue: UseFormSetValue<FiltersProps>;
	reset: UseFormReset<FiltersProps>;
	handleReset: () => void;
}

export const marketplaceOptions = filterVisibleMarketplaceOptions([
	{ label: "Ticketmaster", value: "TICKET_MASTER" },
	{ label: "SeatGeek", value: "SEAT_GEEK" },
	{ label: "GameTime", value: "GAME_TIME" },
	{ label: "Viagogo", value: "VIA_GOGO" },
	{ label: "AXS", value: "AXS" },
	{ label: "TicketNetwork/TickPick", value: "TICKET_NETWORK" },
	{ label: "TicketEvolution", value: "TICKET_EVOLUTION" },
	{ label: "GoTickets", value: "GO_TICKETS" },
	{ label: "Email MP", value: "GENERIC_MP" },
]);

const FiltersModal = ({ control, setValue, handleReset }: FiltersModalProps) => {
	const filterModalRef = useRef<ModalHandle>(null);
	const openModal = () => filterModalRef.current?.openModal();
	const closeModal = () => filterModalRef.current?.closeModal();

	const startDate = useWatch({
		control,
		name: "startDate",
	});

	const endDate = useWatch({
		control,
		name: "endDate",
	});

	const [marketplace, eventHeadliner, venue, eventName] = useWatch({
		control,
		name: ["marketplace", "eventHeadliner", "venue", "eventName"],
		//eslint-disable-next-line @typescript-eslint/no-explicit-any
	}) as Array<any>;

	const filterCount = [marketplace, eventHeadliner, venue, eventName, startDate, endDate]
		.filter(val => val !== undefined && val !== null && val !== "")
		.length;

	if (startDate && endDate) {
		const start = new Date(startDate);
		const end = new Date(endDate);
		if (end < start) {
			setValue("endDate", "");
		}
	}

	const filterButton = (
		<Button style={{ width: "100px" }} type="button" onClick={openModal} variant={ButtonVariant.Quaternary}>
			<FilterButtonInnerContainer>
				<FilterIcon /> Filter
			</FilterButtonInnerContainer>
		</Button>
	);

	return (
		<Modal
			ref={filterModalRef}
			onSave={closeModal}
			onRefresherClick={handleReset}
			title="Filters"
			maxWidth="884px"
			cancelButtonLabel="Close"
			okButtonLabel={`Apply Filters${filterCount > 0 ? ` (${filterCount})` : ""}`}
			customButton={filterButton}>
			<div style={{ marginBottom: "2.5rem", gap: "0.8rem", display: "flex", flexDirection: "column" }}>
				<GridSection headline="Filters" numberOfItems={3}>
					<SelectYup control={control} name={"marketplace"} placeholder={"Marketplace"}
						options={marketplaceOptions} />
					{/* <SelectYup control={control} name={"eventHeadliner"} placeholder={"Headliner"} options={[]} />
					<SelectYup control={control} name={"venue"} placeholder={"Venue"} options={[]} />  */}
					{/* TODO: Restore selects */}
					{/* <Input
						control={control}
						wrapperStyle={{ width: "100%" }}
						type={"text"}
						placeholder={"Marketplace"}
						name={"marketplace"}
						disableXButton
					/> */}
					<Input
						control={control}
						wrapperStyle={{ width: "100%" }}
						type={"text"}
						placeholder={"Headliner"}
						name={"eventHeadliner"}
						disableXButton
					/>
					<Input
						control={control}
						wrapperStyle={{ width: "100%" }}
						type={"text"}
						placeholder={"Venue"}
						name={"venue"}
						disableXButton
					/>
				</GridSection>
				<GridSection numberOfItems={3}>
					<Input
						control={control}
						wrapperStyle={{ width: "100%" }}
						type={"text"}
						placeholder={"Event Name"}
						name={"eventName"}
						disableXButton
					/>
					<DatePickersContainer>
						<DatePicker
							wrapperStyle={{ minWidth: "100px" }}
							control={control}
							placeholder={"Start Date"}
							name={"startDate"}
						// defaultStartDate={new Date()}
						/>
						<DatePicker
							wrapperStyle={{ minWidth: "100px" }}
							control={control}
							placeholder={"End Date"}
							name={"endDate"}
							minDate={startDate ? new Date(startDate) : undefined}
						/>
					</DatePickersContainer>
				</GridSection>
			</div>
		</Modal>
	);
};

export default FiltersModal;
